import { IconProps } from './iconTypes';

export const FlightTakeoff = ({ color, ...props }: IconProps): JSX.Element => (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
        <defs>
            <path id="prefix__a" d="M0 0h24v24H0V0z" />
        </defs>
        <clipPath id="prefix__b">
            <use xlinkHref="#prefix__a" overflow="visible" />
        </clipPath>
        <path
            fill={color}
            d="M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"
            clipPath="url(#prefix__b)"
        />
        <path clipPath="url(#prefix__b)" fill="none" d="M0 0h24v24H0V0z" />
    </svg>
);
